// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3SDPE","requiredAsterisk":"Info_requiredAsterisk__2ukMJ"};